import {useEffect,useState} from 'react';
import {services as fallback} from '@/mocks/services';
import {supabase} from '@/lib/supabase';
import type {Service} from '@/types/content';
export function useServiceCatalog(){
 const [services,setServices]=useState<Service[]>(fallback);
 useEffect(()=>{
  let active=true;
  const refresh=async()=>{
   if(!supabase)return;
   const {data,error}=await supabase.from('services').select('id,precio').eq('activo',true);
   if(active&&!error&&data)setServices(fallback.map(s=>{
    const row=data.find(r=>r.id===s.id);
    return row&&row.precio!==null?{...s,price:Number(row.precio),priceLabel:undefined}:s;
   }));
  };
  void refresh();const timer=window.setInterval(()=>{if(document.visibilityState==='visible')void refresh();},30000);
  window.addEventListener('focus',refresh);return()=>{active=false;window.clearInterval(timer);window.removeEventListener('focus',refresh);};
 },[]);
 return services;
}
